import { v4 as uuid } from 'uuid';

export const selectFieldInitialValues = {
    label: 'Dropdown',
    name: 'dropdown-field',
    items: [{
        id: uuid(),
    }],
    required: false,
};

export const selectFieldForm = [
    {
        id: '1',
        label: 'label',
        name: 'label',
        type: 'text',
        component: 'FormikTextField',
    },
    {
        id: '2',
        label: 'name',
        name: 'name',
        type: 'text',
        component: 'FormikTextField',
    },
    {
        id: '3',
        label: 'Required',
        name: 'required',
        component: 'FormikCheckbox',
    },
    {
        id: '4',
        name: 'items',
        label: 'items',
        type: 'text',
        component: 'FormikListBuilder',
    },
];

export const selectFieldValidation = {};
